import React from 'react';
import '../Default.css';
import './PlaceRender.css'
import type Place from './placesType';


function PlaceRender({place}:{place:Place}) {
  return (
    <>
      <div className="page-title">
        {place.name}
      </div>


      <div className='image-slider'>
        {place.page.img.map((img,i) =>
          <div className='image-slider-frame' key={i}>
            <img src={img.src} alt={img.alt} className='photo' />
            <img src={img.src} alt={img.alt} className='background-photo photo' />
          </div>
        )}
      </div>

      {place.page.sightseeing && <div>
        {place.page.sightseeing}
      </div>}


      {place.page.body?.map((slice,i) =>
        <div className='text' key={i}>
          {slice.paragraf?.map((par,i) =>
            <div className='paragraf' key={i}>
              {par}
            </div>
          )}

          {slice.section?.map((sec,sec_i) =>
            <div key={sec_i}>
              <div className='text-box-header'>{sec.title}</div>
              {sec.text.map((elem,i) =>
                <div className='paragraf' key={i}>
                  {elem}
                </div>
              )}
            </div>
          )}

          {slice.img?.map((elem,gi) =>
            <div className='described-image-box' key={gi}>
              <img src={elem.img.src} alt={elem.img.alt} className='photo' />
              <ol>
                {elem.description.map((par,i) =>
                  <li key={i}>{par}</li>
                )}
              </ol>
            </div>
          )}

          {slice.ul?.map((ul,gi) =>
            <div key={gi}>
              <div className='list-header' >
                {ul.header}
              </div>
              <ul>
                {ul.li.map((par) =>
                  <li>{par}</li>
                )}
              </ul>
            </div>
          )}
        </div>
      )}

      <div className='copyright'>
        {place.copyright?.books?.map( (source,p_i) => (
          <p key={p_i}>{source}</p>
        ))}
        {place.copyright?.websides?.map((source,p_i) => (
          <a href={source} key={p_i}>{source}</a>
        ))}
      </div>
    </>
  );
}

export default PlaceRender;